<template>
  <draggable v-model="dcf.lignesCommande" @change="$emit('change')"
             handle='.draggable-handle'
             :disabled="dcfIsCommandePartiellement">
    <div v-for="(ligneCommande) in lignesCommandeToDisplay" :key="ligneCommande.ordre">
      <app-articles
        ref="ligneCommandeBasique"
        v-if="ligneCommande.type === constantes.NORMAL
                && !ligneCommande.referencePersonnalise"
        class="mgb-25px"
        :class="getBackgroundColorClass(ligneCommande)"
        :lignesCommande="dcf.lignesCommande"
        :ligneCommande="ligneCommande"
        :devisCommande="dcf"
        :error="error"
        :commandeAchatARapprocher="commandeAchatARapprocher"
        :canDelete="checkCanDelete(ligneCommande)"
        :sens="sens"
        :disabled="disabledLine(ligneCommande)"
        :disabledDraggable="dcfIsCommandePartiellement"
        :isCreditNote="isCreditNote"
        :isAvoirLibre="isAvoirLibre"
        :modulePresseActive="modulePresseActive"
        :filtrerProduitParSociete="filtrerProduitParSociete"
        :regimesTva="regimesTva"
        :categoriesProduct="categoriesProduct"
        @reloadTotalHt="$emit('reloadTotalHt')"
        @modificationLigneCommande="modifLigneCommande"/>
      <app-sous-total v-if="ligneCommande.type === constantes.SOUS_TOTAL"
                      class="mgb-25px"
                      :class="getBackgroundColorClass(ligneCommande)"
                      :lignesCommande="dcf.lignesCommande"
                      :disabledDraggable="dcfIsCommandePartiellement"
                      :ligneCommande="ligneCommande"
                      :error="error"
                      @reloadTotalHt="$emit('reloadTotalHt')"/>
      <app-personnalise ref="ligneRegroupementPersonnalise"
                        v-if="ligneCommande.type === constantes.PERSONNALISE"
                        class="mgb-25px"
                        :class="getBackgroundColorClass(ligneCommande)"
                        :lignesCommande="dcf.lignesCommande"
                        :canDelete="checkCanDelete(ligneCommande)"
                        :ligneCommande="ligneCommande"
                        :disabledDraggable="dcfIsCommandePartiellement"
                        :devisCommande="dcf"
                        :error="error"
                        :disabled="disabledLine(ligneCommande)"
                        :isCreditNote="isCreditNote"
                        :isAvoirLibre="isAvoirLibre"
                        :modulePresseActive="modulePresseActive"
                        :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
                        :filtrerProduitParSociete="filtrerProduitParSociete"
                        :activationYield="activationYield"
                        :regimesTva="regimesTva"
                        @reloadTotalHt="$emit('reloadTotalHt')"
                        @modificationLigneCommande="modifLigneCommande"
                        @dissocierPersonnalise="$emit('dissocierPersonnalise', $event)" />
      <app-commentaire v-if="ligneCommande.type === constantes.COMMENTAIRE"
                       class="mgb-25px"
                       :class="getBackgroundColorClass(ligneCommande)"
                       :lignesCommande="dcf.lignesCommande"
                       :ligneCommande="ligneCommande"
                       :disabledDraggable="dcfIsCommandePartiellement"
                       :error="error"/>
      <app-ligne-regroupement
        ref="ligneRegroupement"
        v-if="ligneCommande.type === constantes.REGROUPEMENT
                && !ligneCommande.referencePersonnalise && !isLoadingDisponibilite"
        :devisCommande="dcf"
        class="mgb-25px"
        :class="getBackgroundColorClass(ligneCommande)"
        :lignesCommande="dcf.lignesCommande"
        :canDelete="checkCanDelete(ligneCommande)"
        :ligneCommande="ligneCommande"
        :disabledDraggable="dcfIsCommandePartiellement"
        racineTraduction="ajoutDevis"
        :isCreditNote="isCreditNote"
        :isAvoirLibre="isAvoirLibre"
        :sens="sens"
        :disabled="disabledLine(ligneCommande)"
        :modulePresseActive="modulePresseActive"
        :periodeTotalCalculTlpeAuto="periodeTotalCalculTlpeAuto"
        :filtrerProduitParSociete="filtrerProduitParSociete"
        :activationYield="activationYield"
        :regimesTva="regimesTva"
        @reloadTotalHt="$emit('reloadTotalHt')"
        @messagesErrors="$emit('messagesErrors', $event)"
        @modificationLigneCommande="modifLigneCommande"
        :ouverturePopup="!ligneCommande.id
                            && ordreDernierAjoute
                            && ligneCommande.ordre === ordreDernierAjoute"
        :error="error"
        :disponibiliteTempo="getDisponibilitesofTempo(ligneCommande)"/>
      <app-ligne-remise v-if="ligneCommande.type === constantes.REMISE"
                        class="mgb-25px"
                        :class="getBackgroundColorClass(ligneCommande)"
                        :lignesCommande="dcf.lignesCommande"
                        :disabledDraggable="dcfIsCommandePartiellement"
                        :diabled = disabledLine(ligneCommande)
                        :ligneCommande="ligneCommande"
                        @reloadTotalHt="$emit('reloadTotalHt')"/>
    </div>
  </draggable>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import draggable from 'vuedraggable';
import Articles from '@/components/devisCommandes/editionDevisCommande/m_ligneCommandeBasique';
import LigneRegroupement from '@/components/devisCommandes/editionDevisCommande/m_ligneProduit';
import SousTotal from '@/components/devisCommandes/editionDevisCommande/sousTotal';
import RegroupementPersonnalise from '@/components/devisCommandes/editionDevisCommande/regroupementPersonnalise';
import Commentaire from '@/components/devisCommandes/editionDevisCommande/m_ligneCommentaire';
import ligneRemise from '@/components/devisCommandes/editionDevisCommande/m_ligneRemise';
import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_DISPOSITIF } from '@/configuration/catalogue/produitConf';
import { ETAT_NON_RAPPROCHE_TYPE } from '@/configuration/achat/bonReception/rapprochementConfig';
import getAllDisponibilitesOfTempo from '@/services/devisCommandes/getDisponibiliteOfAllTempo';
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { checkIfLigneCanBeDeletedWithBesoin } from '@/services/bodac/besoin/besoinService';
import { GUID_VIDE } from '@/configuration/general';

export default {
  props: {
    dcf: {
      type: Object,
      required: true,
      default: null,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: false,
    },
    isCreditNote: {
      type: Boolean,
      required: true,
    },
    isAvoirLibre: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    sens: {
      type: String,
      required: true,
    },
    ordreDernierAjoute: {
      type: Number,
      required: false,
      default: null,
    },
    lignesCommandeToDisplay: {
      type: Array,
      required: true,
      default: null,
    },
    modulePresseActive: {
      type: Boolean,
      required: true,
    },
    periodeTotalCalculTlpeAuto: {
      type: Boolean,
      required: true,
    },
    filtrerProduitParSociete: {
      type: Boolean,
      required: true,
    },
    activationYield: {
      type: Boolean,
      required: true,
    },
    regimesTva: {
      type: Array,
      required: true,
    },
    categoriesProduct: {
      type: Array,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      constantes: {
        NORMAL: devisConf.NORMAL,
        SOUS_TOTAL: devisConf.SOUS_TOTAL,
        PERSONNALISE: devisConf.PERSONNALISE,
        COMMENTAIRE: devisConf.COMMENTAIRE,
        REMISE: devisConf.REMISE,
        REGROUPEMENT: devisConf.REGROUPEMENT,
      },
      reseauxTempoDisponibilites: {},
      isLoadingDisponibilite: false,
    };
  },
  components: {
    draggable,
    appArticles: Articles,
    appLigneRegroupement: LigneRegroupement,
    appSousTotal: SousTotal,
    appPersonnalise: RegroupementPersonnalise,
    appCommentaire: Commentaire,
    appLigneRemise: ligneRemise,
  },
  computed: {
    dcfIsCommandePartiellement() {
      return this.dcf.etat === devisConf.ETAT_COMMANDE_PARTIELLEMENT;
    },
  },
  methods: {
    checkCanDelete(ligneToCheck) {
      const referenceToCheck = [];
      if (ligneToCheck.ligneCommandeDispositif && ligneToCheck.ligneCommandeDispositif.dispositif
        && ligneToCheck.typeProduit === CATEGORIE_DISPOSITIF
        && ligneToCheck.ligneCommandeDispositif.dispositif.id !== GUID_VIDE) {
        return ligneToCheck.ligneCommandeDispositif.dispositif.brouillon;
      }
      if (this.dcf.etat === devisConf.ETAT_FACTURE) return false;
      if (this.dcf.etat !== devisConf.ETAT_FACTURE_PARTIELLEMENT) {
        return checkIfLigneCanBeDeletedWithBesoin(ligneToCheck, this.dcf);
      }
      if (ligneToCheck.type === devisConf.PERSONNALISE) {
        const lignes = this.dcf.lignesCommande.filter((ligneDcf) => {
          return ligneDcf.referencePersonnalise === ligneToCheck.referencePersonnalise;
        });
        lignes.forEach((ligne) => {
          if (ligne.referenceEcheancier) referenceToCheck.push(ligne.referenceEcheancier);
          if (ligne.lignesCommande) {
            ligne.lignesCommande.forEach((ligneEnf) => {
              if (ligneEnf.referenceEcheancier) referenceToCheck.push(ligneEnf.referenceEcheancier);
            });
          }
        });
      } else {
        if (ligneToCheck.referenceEcheancier) {
          referenceToCheck.push(ligneToCheck.referenceEcheancier);
        }
        if (ligneToCheck.lignesCommande) {
          ligneToCheck.lignesCommande.forEach((ligne) => {
            if (ligne.referenceEcheancier) referenceToCheck.push(ligne.referenceEcheancier);
          });
        }
      }
      let canDelete = checkIfLigneCanBeDeletedWithBesoin(ligneToCheck, this.dcf);
      this.dcf.echeanciers.forEach((echeancier) => {
        if (!referenceToCheck.includes(echeancier.referenceEcheancier)) return;
        if (echeancier.echeancierLignes.some((echLigne) => echLigne.facturationFaite)) {
          canDelete = false;
        }
      });
      return canDelete;
    },
    disabledLine(line) {
      const disabledForDevis = !!line.commandeId
        && this.dcf.type === devisConf.TYPE_DEVIS;
      const disabbledForCommandeAchat = this.dcf.type === devisConf.TYPE_COMMANDE
        && this.dcf.module === devisConf.MODULE_ACHAT
        && this.dcf.sens === devisConf.SENS_ACHAT
        && this.dcf.sousType === devisConf.SOUS_TYPE_NORMAL
        && line.lieuxLivraisons?.length > 0
        && line.lieuxLivraisons.some(ll => {
          return !!ll.etatRapprochement && ll.etatRapprochement !== ETAT_NON_RAPPROCHE_TYPE;
        })
        && !!line.id && !!this.dcf.id;
      return disabledForDevis || disabbledForCommandeAchat;
    },
    modifLigneCommande(lignecommande, ordre) {
      this.$emit('modificationLigneCommande', lignecommande, ordre);
    },
    updateTypeRemiseLocal() {
      if (this.$refs.ligneCommandeBasique) {
        this.$refs.ligneCommandeBasique.forEach((ligne) => {
          ligne.updateTypeRemiseLocal();
        });
      }
      if (this.$refs.ligneRegroupement) {
        this.$refs.ligneRegroupement.forEach((ligne) => {
          ligne.updateTypeRemiseLocal();
        });
      }
    },
    getBackgroundColorClass(ligneCommande) {
      if (ligneCommande.isDuplicated) return 'has-background-table-border';
      return 'has-background-table-second-color';
    },
    async getAllDisponibilitesOfTempo() {
      this.isLoadingDisponibilite = true;
      try {
        const copyLigne = cloneDeep(this.lignesCommandeToDisplay);
        const copyLigneFilter = copyLigne
          .filter((ligne) => {
            return ligne.produitId && ligne.type === this.constantes.REGROUPEMENT
                && ligne.typeProduit === produitConf.CATEGORIE_REGROUPEMENT;
          });
        if (copyLigneFilter.length === 0) {
          this.isLoadingDisponibilite = false;
          return;
        }
        const produitsId = copyLigneFilter.map((ligne) => ligne.produitId);
        const produitsIdWithoutDuplicate = [...new Set(produitsId)];
        const datesListes = copyLigneFilter.map((el) => {
          return {
            dateDebut: el.dateDebut,
            dateFin: el.dateFin,
          };
        });
        const minDateDebut = datesListes.map((el) => {
          return el.dateDebut;
        }).sort((a, b) => moment(a).diff(b))[0];
        const maxDateFin = datesListes.map((el) => {
          return el.dateFin;
        }).sort((a, b) => moment(b).diff(a))[0];

        this.reseauxTempoDisponibilites = await getAllDisponibilitesOfTempo(
          produitsIdWithoutDuplicate, minDateDebut, maxDateFin,
        );
        this.isLoadingDisponibilite = false;
      } catch (e) {
        this.isLoadingDisponibilite = false;
        messageErreur(this.$$i18n);
        throw e;
      }
    },
    getDisponibilitesofTempo(ligneCommande) {
      const disponibilite = this.reseauxTempoDisponibilites[ligneCommande.produitId]
        ?.find((el) => {
          return el.anneeSemaine === ligneCommande.ligneReseau.anneeSemaine
              && el.jourDepart === ligneCommande.ligneReseau.jourDepart;
        });
      return disponibilite;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.dcf.type !== devisConf.TYPE_FACTURE) {
        await this.getAllDisponibilitesOfTempo();
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
